/**
 * @generated SignedSource<<1d4656e1c9cc75319c86553bf672018a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerAccountId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "resellerAccountId",
        "variableName": "resellerAccountId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "PROGRAM_NAME_ASC"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qualificationPeriod",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMin",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePerc",
  "storageKey": null
},
v16 = [
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v19 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v18/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerCommProgramsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ResellerProgramTsConnection",
        "kind": "LinkedField",
        "name": "allResellerProgramTs",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ResellerProgramLineTsConnection",
                "kind": "LinkedField",
                "name": "resellerProgramLineTsByResellerPId",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ResellerProgramLineT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppT",
                "kind": "LinkedField",
                "name": "customerAppTByCustomerAppId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountT",
                    "kind": "LinkedField",
                    "name": "accountTByCustomerAccountId",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CpT",
                "kind": "LinkedField",
                "name": "cpTByCpId",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CpLineTsConnection",
                    "kind": "LinkedField",
                    "name": "cpLineTsByCpId",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CpLineT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerCommProgramsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ResellerProgramTsConnection",
        "kind": "LinkedField",
        "name": "allResellerProgramTs",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ResellerProgramLineTsConnection",
                "kind": "LinkedField",
                "name": "resellerProgramLineTsByResellerPId",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ResellerProgramLineT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppT",
                "kind": "LinkedField",
                "name": "customerAppTByCustomerAppId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountT",
                    "kind": "LinkedField",
                    "name": "accountTByCustomerAccountId",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CpT",
                "kind": "LinkedField",
                "name": "cpTByCpId",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CpLineTsConnection",
                    "kind": "LinkedField",
                    "name": "cpLineTsByCpId",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CpLineT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ad108eda46a6184a5928483f8215cd39",
    "id": null,
    "metadata": {},
    "name": "ResellerCommProgramsQuery",
    "operationKind": "query",
    "text": "query ResellerCommProgramsQuery(\n  $resellerAccountId: UUID!\n  $first: Int\n  $offset: Int\n) {\n  allResellerProgramTs(condition: {resellerAccountId: $resellerAccountId}, orderBy: PROGRAM_NAME_ASC, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      resellerPId\n      cpId\n      description\n      programType\n      programName\n      qualificationPeriod\n      notes\n      active\n      customerAppId\n      resellerProgramLineTsByResellerPId {\n        totalCount\n        nodes {\n          revenueMin\n          incentivePerc\n          nodeId\n        }\n      }\n      customerAppTByCustomerAppId {\n        accountTByCustomerAccountId {\n          accountName\n          nodeId\n        }\n        nodeId\n      }\n      cpTByCpId {\n        programName\n        programType\n        qualificationPeriod\n        cpLineTsByCpId {\n          totalCount\n          nodes {\n            revenueMin\n            incentivePerc\n            nodeId\n          }\n        }\n        nodeId\n      }\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e80ae8ce26152ad1033a419b1c1da5ba";

module.exports = node;
